import {Contract} from './Contract';
import {BaseObject} from './BaseObject';
import {ContractState} from './ContractState';

export class Availability extends BaseObject {
    available = false;
    availability: AvailabilityDayRecord[];

}

export class AvailabilityDayRecord extends Object {
    date: Date;
    total: number;
    available_count: number;
    dispatched: AvailabilityDayStatus;
    store_delay: AvailabilityDayStatus;
    store_delay_before: AvailabilityDayStatus;
    delayed: AvailabilityDayStatus;
    // contracts: Contract[];

    contracts = (): any[] => {
        const contracts = [];

        contracts.concat(this.dispatched.contracts);
        contracts.concat(this.store_delay.contracts);
        contracts.concat(this.delayed.contracts);

        return contracts;
    }
}

export class AvailabilityDayStatus extends Object {
    contracts: AvailabilityContract[];
    count: number;
}

export class AvailabilityContract extends Object {
    contractId: number;
    contractItemId: number;
    count: number;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Availability.ts